import React, {useState} from 'react';
import SummaryGridView from "../../Accounting/SummaryGridView";
import {Box, Button, Card, CardActions} from "@mui/material";
import localStrings from "../../../localStrings";
import {executeMutationUtil} from "../../../utils/gqlUtil";
import {updateDataGridImplementationMutation} from "../../../gql/dataGridImplementationGql";
import enqueueSnackbarWithSound from "../../../utils/SnackBarWithSound";
import toast from "react-hot-toast";
import {decode as base64_decode, encode as base64_encode} from "base-64";

function GridEdit({dataGridImplementation, reloadTrigger}) {
    function getInitialState() {
        if (dataGridImplementation && dataGridImplementation.pivotModelContent) {
            return JSON.parse(base64_decode(dataGridImplementation.pivotModelContent));
        }
        return {"rows": [], "columns": [], "values": []};
    }

    const [pivotModel, setPivotModel] = useState(
        getInitialState());

    const [pivotActive, setPivotActive] = useState(dataGridImplementation?.usePivot || false);

    const saveForm = async () => {
        let data;
        // if (!modeEdit || modeEdit == MODE_EDIT) {
        data = {
            ...dataGridImplementation,
            pivotModelContent:base64_encode(JSON.stringify(pivotModel)),
            usePivot: pivotActive,
        };
        await executeMutationUtil(updateDataGridImplementationMutation(data));
        reloadTrigger();
        enqueueSnackbarWithSound(toast, null, null,
            localStrings.notif.dataGridImplementationUpdated);
    }

    return (
        <Card>
            <SummaryGridView
                pivotModel={pivotModel}
                setPivotModel={setPivotModel}
                pivotActive={pivotActive}
                setPivotActive={setPivotActive}
            />

            <CardActions>
                <div style={{width: '100%'}}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row-reverse',
                            p: 1,
                            m: 1,
                            borderRadius: 1,
                        }}
                    >

                        <Box>
                            <Button
                                onClick={() => {
                                    saveForm();                                    // clearChartDataCacheByImplementationId(chartImplementationId, filter);
                                }}
                                variant="contained"

                            >
                                {"" + localStrings.update}
                            </Button>


                        </Box>
                    </Box>
                </div>
            </CardActions>
        </Card>
    )
}

export default GridEdit